import styled from 'styled-components';
import { px2rem } from '../../../../stylesheets/tools';

const StyledEducationRefinementSlider = styled.div`
  padding: ${px2rem('12px')} ${px2rem('12px')} 0 ${px2rem('12px')};

  .DefaultProgressBar_progressBar {
    background-color: #000;
  }
  .DefaultBackground {
    border-color: #000;
  }
  .DefaultProgressBar_background__horizontal {
    height: 14px;
    top: -1px;
  }
  .refinement__range-state {
    display: flex;
    justify-content: space-between;
    margin: 10px -12px 0 -12px;
  }

  .handleContainer .DefaultHandle_handle_1:first-child {
    z-index: 3;
  }

  .DefaultHandle_handle {
    border-radius: 0px;
    box-shadow: none;
    background-color: white;
    background-image: linear-gradient(180deg, currentColor, currentColor),
      linear-gradient(225deg, currentColor, currentColor),
      linear-gradient(0deg, currentColor, currentColor),
      linear-gradient(90deg, currentColor, currentColor),
      linear-gradient(
        135deg,
        transparent 9px,
        currentColor 9px,
        currentColor 11px,
        transparent 11px
      );
    background-position: top right, top right, bottom left, bottom left, top left;
    background-size: calc(100% - 13px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 13px), 120px 120px;
    background-repeat: no-repeat;
    border: unset;
    height: 34px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.DefaultHandle_handle__horizontal {
      top: -12px;
    }

    &:before {
      margin-top: 4px;
      content: url('/static/svg/sliderThumb.svg');
      position: unset;
      height: 12px;
      background: none;
      width: 12px;
    }
    &:after {
      content: none;
    }
  }
`;

export default StyledEducationRefinementSlider;
